export default {"src":"/_next/static/media/dashboard-slide-arrow-icon.3b64b470.svg","height":51,"width":24,"blurWidth":0,"blurHeight":0};